import { INITIAL_PAGE_NUMBER, INITIAL_SIZE } from '../../../constants/general';

export default function educationDetails(
  initialState = {
    educations: [],
    pageNumber: INITIAL_PAGE_NUMBER,
    search: '',
    size: INITIAL_SIZE,
    totalRecords: 0,
    sortBy: 'StartDateOfInterviewRound',
    orderBy: 'DESC'
  },
  action
) {
  switch (action.type) {
    case 'SET_EDUCATIONS':
      return {
        ...initialState,
        educations: action.payload
      };

    case 'SET_EDUCATIONS_SEARCH':
      return {
        ...initialState,
        search: action.payload
      };

    case 'SET_EDUCATIONS_PAGE_NUMBER':
      return {
        ...initialState,
        pageNumber: action.payload
      };

    case 'SET_EDUCATIONS_PAGE_SIZE':
      return {
        ...initialState,
        size: action.payload
      };

    case 'SET_EDUCATIONS_SORT_BY':
      return {
        ...initialState,
        sortBy: action.payload
      };

    case 'SET_EDUCATIONS_ORDER_BY':
      return {
        ...initialState,
        orderBy: action.payload
      };

    case 'SET_EDUCATIONS_TOTAL_RECORDS':
      return {
        ...initialState,
        totalRecords: action.payload
      };

    case 'EDUCATIONS_RESET':
      return {
        ...initialState,
        educations: [],
        pageNumber: INITIAL_PAGE_NUMBER,
        search: '',
        size: INITIAL_SIZE,
        totalRecords: 0,
        sortBy: 'StartDateOfInterviewRound',
        orderBy: 'DESC'
      };

    default:
      return initialState;
  }
}
